import styled from 'styled-components'
import { Button } from 'semantic-ui-react'

const ConvertButton = styled(Button)`
  && {
    width: 50%;
    min-width: 200px;
    border-radius: 8px;
    padding: 14px 0;
  }
`
export default ConvertButton
